/**
 * A file somebody hands the designer to work from.
 *
 * A brief, a brand sheet, a screenshot of last year's newsletter, the logo, an
 * existing email saved as html. **The point is that the design should not have
 * to be described in words when it already exists in a file.**
 *
 * **Nothing here is stored.** A reference is carried into one request and
 * forwarded to the model; what survives is the brand profile learned from it,
 * which is text. That keeps the product out of the business of holding
 * customers' files — no bucket, no retention policy, no second place a logo can
 * leak from — and it is why these carry their bytes rather than a location.
 */
/**
 * How many references one turn may carry, and how large each may be.
 *
 * Five megabytes is comfortably above a brand sheet or a screenshot and well
 * below the point where a request stops arriving. The total matters separately:
 * ten files just under the individual limit is a body no proxy will pass.
 *
 * These are the domain's numbers so the contract, the screen and the adapter
 * cannot disagree about them — a screen that accepts a file the server refuses
 * is a screen that wastes an upload to say no.
 */
export const MOST_REFERENCES = 10;
export const MOST_REFERENCE_BYTES = 5 * 1024 * 1024;
export const MOST_REFERENCE_BYTES_TOTAL = 12 * 1024 * 1024;
/** Base64 carries three bytes in four characters, so the encoded form is larger. */
export function decodedBytes(base64) {
    const padding = base64.endsWith('==') ? 2 : base64.endsWith('=') ? 1 : 0;
    return Math.max(0, Math.floor((base64.length * 3) / 4) - padding);
}
//# sourceMappingURL=designReference.js.map